import { NgModule } from '@angular/core';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';

import { LegendComponent } from './legend/legend.component';
import { AnatomicMapDirective } from './map/anatomicMapDirective/anatomic-map.directive';
import { MapComponent } from './map/map.component';
import { CommonModule } from '@angular/common';
import { MapContainerComponent } from './map-container/map-container.component';
import { AnatomicMapTooltipComponent } from './components/anatomic-map-tooltip/anatomic-map-tooltip.component';
import { AnatomicMapTooltipDirective } from './components/anatomic-map-tooltip/anatomic-map-tooltip.directive';
import { LegendButtonComponent } from './components/legend-button/legend-button.component';
import { MultiStageMapContainerComponent } from './multistage-map-container/multistage-map-container.component';
import { MapLoadingComponent } from './components/map-loading/map-loading.component';

@NgModule({
    declarations: [
        MapContainerComponent,
        MultiStageMapContainerComponent,
        MapComponent,
        AnatomicMapDirective,
        AnatomicMapTooltipComponent,
        AnatomicMapTooltipDirective,
        LegendComponent,
        LegendButtonComponent,
        MapLoadingComponent,
    ],
    imports: [
        CommonModule,
        TranslateModule,
    ],
    exports: [MapContainerComponent, MultiStageMapContainerComponent, MapComponent, LegendComponent, MapLoadingComponent],
})
export class SeUiAnatomicMapModule {}
